<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-pound-sign</v-icon>
      <v-toolbar-title class="ml-0 pl-3">Billing</v-toolbar-title>
    </v-app-bar>
    <v-content class="grey lighten-2">
      <BillTableView></BillTableView>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BillTableView from '@/components/Platform/Bills/BillTableView';

export default {
  components: {
    BillTableView
  },
  data: () => ({
    search: '',
    showNewBillDialog: false
  }),
  name: 'Bills',
  computed: {
    ...mapGetters(['UserName', 'UILeftDrawer']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState'])
  }
};
</script>

<style lang="scss" scoped></style>
